module.exports = __webpack_public_path__ + "assets/static/svg/success.9502ae32c733bdb8f564e5b268cb15c3.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/images/success.svg
 ** module id = 532
 ** module chunks = 1
 **/